"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_webview_1 = require("react-native-webview");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const react_native_1 = require("react-native");
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const UserContext_1 = require("../contexts/UserContext");
const react_i18next_1 = require("react-i18next");
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const WebScreen = ({ route, navigation }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const STYLES = (0, Theme_1.useGlobalStyles)();
    const [canDownload] = react_1.default.useState(route.params.canDownload);
    console.info(canDownload);
    const [downloading, setDownloading] = react_1.default.useState(false);
    const [pdfUri, setPdfUri] = react_1.default.useState(null);
    const webview = react_1.default.useRef(null);
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const safe = (0, react_native_safe_area_context_1.useSafeAreaInsets)();
    let userAgent = null;
    let javaScript = null;
    if (route.params.desktopUserAgent) {
        userAgent = 'Mozilla/5.0 (Windows NT 10.0) '
            + 'AppleWebKit/537.36 (KHTML, like Gecko) '
            + 'Chrome/138.0.0.0 Safari/537.36';
    }
    if (route.params.desktopViewport) {
        javaScript = 'var m = document.createElement("meta");'
            + 'm.content = "width=800";'
            + 'm.name = "viewport";'
            + 'document.head.append(m);';
    }
    const [source, setSource] = react_1.default.useState(() => {
        if (route.params.token) {
            return {};
        }
        else {
            return { uri: route.params.uri, headers: { referer: route.params.referer } };
        }
    });
    react_1.default.useEffect(() => {
        if (route.params.token) {
            userContext.getToken().then(token => {
                setSource({
                    uri: route.params.uri,
                    headers: {
                        Authorization: `Bearer ${token.token}`,
                        'Nextep-Client': token.client,
                        'Nextep-Platform': 'mobile',
                        referer: route.params.referer
                    }
                });
            });
        }
        return () => {
            if (canDownload)
                react_native_1.DeviceEventEmitter.removeAllListeners("event.downloadPdf");
        };
    }, []);
    const onDownload = () => {
        setDownloading(true);
        react_native_1.DeviceEventEmitter.emit("event.downloadPdf", {});
        setTimeout(() => {
            setDownloading(false);
        }, 2000);
    };
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flex: 1, paddingBottom: safe.bottom, backgroundColor: THEME.PrimaryDark }, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                    height: 44, flexDirection: 'row', alignItems: 'center',
                    backgroundColor: THEME.PrimaryDark, borderBottomColor: '#00000044', borderBottomWidth: 1
                }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, justifyContent: 'center', marginLeft: 12 }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { "aria-label": route.params["aria-label"], style: { fontSize: 18, fontWeight: '500', color: THEME.AlwaysWhite }, children: route.params.title }) }), canDownload && !downloading &&
                        (0, jsx_runtime_1.jsx)(react_native_1.Pressable, { "aria-label": t('common:buttons.close'), style: ({ pressed }) => [{ paddingHorizontal: 12, paddingVertical: 8 }, (pressed ? STYLES.pressedOpacity : null)], onPress: onDownload, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.ArrowDownToLine, size: 20, style: { color: '#fff' } }) }), canDownload && downloading &&
                        (0, jsx_runtime_1.jsx)(react_native_1.ActivityIndicator, { style: { paddingHorizontal: 12, paddingVertical: 8 }, color: "#fff", size: "small" }), (0, jsx_runtime_1.jsx)(react_native_1.Pressable, { "aria-label": t('common:buttons.close'), onPress: (e) => navigation.goBack(), style: ({ pressed }) => [{ paddingHorizontal: 12, paddingVertical: 8 }, (pressed ? STYLES.pressedOpacity : null)], children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.Xmark, size: 20, style: { color: THEME.AlwaysWhite } }) })] }), (0, jsx_runtime_1.jsx)(react_native_webview_1.WebView, { ref: webview, source: source, allowFileAccess: true, startInLoadingState: true, geolocationEnabled: true, overScrollMode: "never", userAgent: userAgent, setSupportMultipleWindows: false, injectedJavaScript: javaScript, onMessage: () => null, renderLoading: () => (0, jsx_runtime_1.jsx)(react_native_1.ActivityIndicator, { color: THEME.Secondary, size: "large", style: { position: 'absolute', width: '100%', height: '100%' } }), 
                // TODO: Update this to be independent of Prism
                // https://github.com/nextep-inc/nextep-application/issues/320
                onNavigationStateChange: route.params.autoNavInjection === '' ? null : (navState) => {
                    if (navState.url.endsWith('home')) {
                        webview.current.injectJavaScript(route.params.autoNavInjection);
                    }
                } })] }));
};
exports.default = WebScreen;
